/** Префикс пути списка локаций, например "/location-list" при PUBLIC_URL="/". */
export const getLocationListPrefix = () => {
  const p = process.env.PUBLIC_URL || "";
  const trimmed = p.replace(/\/$/, "");
  if (trimmed === "" || trimmed === "/") {
    return "/location-list";
  }
  return `${trimmed}/location-list`;
};

const normalizePath = (pathname) => {
  if (!pathname) return "/";
  const t = pathname.replace(/\/$/, "");
  return t || "/";
};

/**
 * Контекст «локация открыта в cpai» для сайдбара: непустой location_id в query
 * и страница не сводится к одному только списку локаций /location-list.
 */
export const isLocationSidebarContext = (pathname, search) => {
  const locationId = new URLSearchParams(search).get("location_id");
  if (!locationId || !String(locationId).trim()) {
    return false;
  }
  const listPrefix = normalizePath(getLocationListPrefix());
  const path = normalizePath(pathname);
  if (path === listPrefix || path === `${listPrefix}/add`) {
    return false;
  }
  return true;
};
